class FreeProducts {
  constructor() {
    this.freeProductId = 8347716518046;
    const events = [
      "product-form-submitted",
      "cart-item-removed",
      "DOMContentLoaded",
    ];
    events.forEach((event) => {
      document.addEventListener(event, async (e) => {
        if (event === "product-form-submitted" || event === "cart-item-removed") {
          await this.updateCartSections();
        }

        const cartItems = await this.getCartData();
        if (!cartItems) {
          return;
        }
        if (!this.findFreeProductInCart(cartItems)) {
          await this.addProducts([{ id: 45670026379422, quantity: 1 }]);
       } else if (this.findFreeProductInCart(cartItems) === "remove") {
          await this.clearCart();
        }
      });
    });
  }

  async updateCartSections(openCartDrawer) {
    try {
      const response = await fetch("/cart.json");
      const responseJson = await response.json();
      const cartItems = document.querySelector("cart-items");
      const cartDrawerItems = document.querySelector("cart-drawer-items");
      if (!!cartItems) {
        location.reload();
        return; //temporary fix to avoid updating cart items
        const cartFooter = document.getElementById("main-cart-footer");
        const responseCartItems = await fetch("/?sections=main-cart-items");
        const responseCartItemsJson = await responseCartItems.json();
        let mainCartItems = new DOMParser()
          .parseFromString(
            responseCartItemsJson["main-cart-items"],
            "text/html"
          )
          .querySelector(".js-contents").innerHTML;
        document.getElementById("main-cart-items").innerHTML = mainCartItems;
        cartItems.classList.toggle("is-empty", responseJson.item_count === 0);
        if (cartFooter) {
          cartFooter.classList.toggle(
            "is-empty",
            responseJson.item_count === 0
          );
        }
      }

      // not on cart page -- update cart drawer
      else if (!!cartDrawerItems) {
        const responseCartDrawer = await fetch("/?sections=cart-drawer");
        const responseCartDrawerJson = await responseCartDrawer.json();
        let cartDrawerInner = new DOMParser()
          .parseFromString(responseCartDrawerJson["cart-drawer"], "text/html")
          .querySelector(".drawer__inner").innerHTML;

        document.querySelector(".drawer__inner").innerHTML = cartDrawerInner;
        document
          .querySelector("cart-drawer")
          .classList.toggle("is-empty", responseJson.item_count === 0);

        // update cart count in header
        const responseCartIconBubble = await fetch(
          "/?sections=cart-icon-bubble"
        );
        const responseCartIconBubbleJson = await responseCartIconBubble.json();
        const cartCountBubbleElement =
          document.querySelector(".cart-count-bubble");
        let cartCountBubble = new DOMParser()
          .parseFromString(
            responseCartIconBubbleJson["cart-icon-bubble"],
            "text/html"
          )
          .querySelector(".cart-count-bubble");
        if (cartCountBubbleElement) {
          if (!!cartCountBubble) {
            document.querySelector(".cart-count-bubble").innerHTML =
              cartCountBubble?.innerHTML;
          } else if (cartCountBubbleElement) {
            cartCountBubbleElement.innerHTML = "";
          }
          cartCountBubbleElement.classList.toggle(
            "hidden",
            responseJson.item_count === 0
          );
        }
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      const response = await fetch("/cart.json");
      const responseJson = await response.json();
      if (
        responseJson.items_subtotal_price == 0 &&
        responseJson.item_count > 0
      ) {
        await this.clearCart();
      } else {
        const cartDrawerItems = document.querySelector("cart-drawer-items");
        if (openCartDrawer && !!cartDrawerItems) {
          document.querySelector("cart-drawer").open();
        }
      }
    }
  }

  findFreeProductInCart(cartItems) {
    const findFreeProduct = cartItems.find(
      (item) => item.product_id === this.freeProductId
    );
    if (findFreeProduct) {
      if (cartItems.length === 1) {
        return "remove";
      } else {
        return true;
      }
    }
    return false;
  }

  async getCartData() {
    try {
      const response = await fetch("/cart.json");
      const responseJson = await response.json();

      if (!responseJson || !responseJson.items) {
        return false;
      } else if (responseJson.items.length === 0) {
        return false;
      }

      return responseJson.items;
    } catch (error) {
      console.error("Error:", error);
    }

    await this.addProducts(formData);
  }

  async clearCart() {
    try {
      await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.error("Error:", error);
    } finally {
      await this.updateCartSections();
    }
  }

  async addProducts(items) {
    const formData = {
      items: items,
    };
    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
    } catch (error) {
      console.error("Error:", error);
    } finally {
      await this.updateCartSections();
    }
  }
}

const freeProds = new FreeProducts();